<template>
    <v-dialog v-model="dialog" width="800px">  
        <v-card>
            <v-card-title class="justify-center">{{ adrg.tabel_oms }}</v-card-title>
            <v-divider class="mb-1"></v-divider>
                <v-simple-table height="500px" dense class="mx-2" showRowsBorder="false">
                    <tbody>
                        <tr v-for="(adrgRecord, i) in adrg.tabel_data" :key="i">
                            <td colspan="3" v-if="adrgRecord.type==='adrg'">
                                {{adrgRecord.adrg_dt}} - {{adrgRecord.gebr_naam}}
                                <div v-if="adrg.isProgrammer">Program: {{ adrgRecord.prog }}</div>
                            </td>
                            <td class="noborder mr-5" v-if="adrgRecord.type==='adrf'">&nbsp; &nbsp; {{ adrgRecord.adrf_veld }}</td>
                            <td class="noborder" v-if="adrgRecord.type==='adrf'">{{ adrgRecord.adrf_old }}</td>
                            <td class="noborder" v-if="adrgRecord.type==='adrf'">{{ adrgRecord.adrf_new }}</td>
                            <td class="noborder" colspan="3" v-if="adrgRecord.type==='separator'"></td>
                        </tr>
                    </tbody>   
                </v-simple-table>  
            <v-divider class="mt-1"></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small @click="dialog = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        components: {
        },
    data() {
        return {
            dialog: false,
            adrg: {},
        }
    },
    methods: {
        openAudit(tabel, encrid) {
            this.dialog = false;
            this.$axios.post("ares/json/ares/misc/getAdrg2.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "getAdrg2"
                },
                getAdrg2: {
                    tabel: tabel,
                    encrid: encrid
                }
            }).then(res => {
                if (res.data.error) {
                    console.log(res.data.error);
                } else {
                    this.adrg = res.data.getAdrg2;
                    this.dialog = true;
                }
            });
        },
    }
}
</script>

<style scoped>
    /* selector could be change with your tr td markup */
    .noborder {
        border: 0px !important; 
        height: 12px !important;
    }
</style>